import { SessionWithId } from '../Models/session';
import { auth } from '../firebase/firebase';
import { hashString } from './hashString';

export const getNotSignedInUserSessions: (
    sessions: SessionWithId[],
) => SessionWithId[] = (sessions) => {
    const userHash = hashString(auth.currentUser?.email!);

    const notMySessions = sessions.filter(
        (session) =>
            !session.session.people ||
            !Object.keys(session.session.people).includes(userHash),
    );

    return notMySessions;
};
